import React from 'react';
import AdminNavbar from '../../components/AdminNavbar/AdminNavbar';
import styles from './AdminLayout.module.scss';

const AdminLayout = ({ children }) => {
  return (
    <>
      <AdminNavbar />
      <div className={styles.container}>
        {children}
      </div>
    </>
  );
};

export default AdminLayout;
